export default "__VITE_ASSET__66a643de__"